module.exports = __webpack_public_path__ + "static/media/sidebar-2.0cbce0c9.jpg";